import i18n from '../../../../../i18n'
import t from './strings'
import { CountryCode } from '@doordash/lib-i18n'
import { COUNTRY_SHORTCODES } from '../../../../../constants'

type LegalLinksType = {
  privacyPolicy: string
  ica: string
}

const HELP_BASE_URL = 'https://help.doordash.com/dashers/s'

export const getLegalLinksForCountry = (currentSignUpCountry: {
  [k: string]: boolean
}): LegalLinksType => {
  const currentLanguage = i18n.getCurrentLocale().replace('-', '_')

  if (currentSignUpCountry.isJP) {
    return {
      ica: `${HELP_BASE_URL}/ica-jp?language=${currentLanguage}`,
      privacyPolicy: `${HELP_BASE_URL}/privacy-policy-jp?language=${currentLanguage}`,
    }
  } else if (currentSignUpCountry.isCA) {
    return {
      ica: `${HELP_BASE_URL}/ica-ca?language=${currentLanguage}`,
      privacyPolicy: `${HELP_BASE_URL}/privacy-policy-ca?language=${currentLanguage}`,
    }
  } else if (currentSignUpCountry.isAU) {
    return {
      ica: `${HELP_BASE_URL}/ica-au?language=${currentLanguage}`,
      privacyPolicy: `${HELP_BASE_URL}/privacy-policy-au?language=${currentLanguage}`,
    }
  } else if (currentSignUpCountry.isDE) {
    return {
      ica: `${HELP_BASE_URL}/terms-of-service-de?language=${currentLanguage}`,
      privacyPolicy: `${HELP_BASE_URL}/privacy-policy-de?language=${currentLanguage}`,
    }
  }

  return {
    ica: `${HELP_BASE_URL}/ica-us?language=${currentLanguage}`,
    privacyPolicy: `${HELP_BASE_URL}/privacy-policy-us?language=${currentLanguage}`,
  }
}

type SubtitleProps = {
  signUpSubtitle: string
  finishSubtitle: string
}

export const getSubtitleForCountry = (country: CountryCode): SubtitleProps => {
  switch (country) {
    case COUNTRY_SHORTCODES.NZ:
      return {
        signUpSubtitle: t.subtitleNZ(),
        finishSubtitle: t.subtitleNZ(),
      }
    default:
      return {
        signUpSubtitle: t.subtitle(),
        finishSubtitle: t.finishSigningUp(),
      }
  }
}
